import React, { useEffect } from "react";

import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { ColorTechSpecSection } from "@swo/storefront";
import { FONTS } from "../../../styles/fonts";
import { T } from "../../../components/T";

export function ColorSection(props: ColorTechSpecSection) {
  return (
    <div>
      {props.attributes.map(color => {
        return (
          <div
            key={color.hex}
            css={css`
              display: flex;
              flex-direction: column;
              align-items: center;

              margin: 10px 0;
            `}
          >
            <span
              css={css`
                width: 30px;
                height: 30px;
                border-radius: 50%;

                margin-bottom: 10px;

                background-color: ${color.hex};

                display: inline-block;
              `}
            />
            <span
              css={css`
                ${FONTS.SwarovskiFutura500};
                font-size: 16px;
                color: ${CSS_COLORS.Grey3};
                font-weight: 100;
              `}
            >
              <T>{color.label}</T>
            </span>
          </div>
        );
      })}
    </div>
  );
}
